import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { reportTitals } from '@piqet-angular/shared';

interface GroupedData {
  [key: string]: any[];
}
@Component({
  selector: 'piqet-angular-packaging-matrics',
  templateUrl: './packaging-matrics.component.html',
  styleUrls: ['./packaging-matrics.component.scss'],
})
export class PackagingMatricsComponent implements OnChanges {
  @Input() packagingMatrics: any;
  reportResource = reportTitals;
  tempArrComponentName: any = [];
  tempArrName: any = [];
  impactValues: any = [];
  tempGroupedData!: GroupedData;
  groupedData: any;

  ngOnChanges(changes: SimpleChanges) {
    this.packagingMatrics = changes['packagingMatrics'].currentValue;
    this.packagingMatrics['isExport'] = false;
    this.tempArrComponentName.push(
      this.packagingMatrics.componentItems[0]?.componentName?.split(';')
    );
    this.tempGroupedData = this.packagingMatrics.componentItems.reduce((result: any, item: any) => {
      const categoryId = item.categoryId;
      if (!result[categoryId]) {
        result[categoryId] = [];
      }

      result[categoryId].push(item);

      return result;
    }, {});
    const groupedData = Object.entries(this.tempGroupedData);
    let sortOrder = ['4', '1', '2', '3'];
    this.groupedData = sortOrder.map(order => groupedData.find(item => item[0] === order));
  }

  arrayFunction() {
    for (let i = 0; i < this.packagingMatrics.componentItems.length; i++) {
      this.tempArrName.push(this.packagingMatrics.componentItems[i]?.name);
      this.impactValues.push(this.packagingMatrics.componentItems[i]?.impactValues?.split(';'));
    }
  }

  groupBy(array: any, property: any) {
    return array.reduce((result: any, obj: any) => {
      const key = obj[property];
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(obj);
      return result;
    }, {});
  }

  getRange(x: number): number[] {
    return Array.from({ length: x }, (_, index) => index);
  }
}
